import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { BookingProvider } from "@/lib/booking";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import CaseStudies from "@/pages/CaseStudies";
import Contact from "@/pages/Contact";
import ComingSoon from "@/pages/ComingSoon";
import NotFound from "@/pages/NotFound";
import HowWeWork from "@/pages/HowWeWork";
import ServiceContentStrategy from "@/pages/services/ContentStrategy";
import ServiceBlogContent from "@/pages/services/BlogContent";
import ServiceConversionContent from "@/pages/services/ConversionContent";
import ServiceContentOperations from "@/pages/services/ContentOperations";

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout({ children }) {
  useLenis();
  return (
    <div className="grain relative">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <BookingProvider>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/content-strategy" element={<ServiceContentStrategy />} />
                <Route path="/services/blog-content" element={<ServiceBlogContent />} />
                <Route path="/services/conversion-content" element={<ServiceConversionContent />} />
                <Route path="/services/content-operations" element={<ServiceContentOperations />} />
                <Route path="/how-we-work" element={<HowWeWork />} />
                <Route path="/process" element={<HowWeWork />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<NotFound />} />
                <Route path="/blog/:slug" element={<NotFound />} />
                <Route path="/about" element={<ComingSoon />} />
                <Route path="/resources" element={<ComingSoon />} />
                <Route path="/careers" element={<ComingSoon />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          </BookingProvider>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
